var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFiquePorDentroBackground = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 96,
    viewBox: "0 0 204 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.862 -5.21343C8.80397 -5.54047 3.24334 -3.29103 2.44268 -0.191562L-25.6051 88.4461C-26.4059 91.5462 -22.1455 94.3258 -16.0875 94.6528L167.21 104.548C173.268 104.875 178.828 102.626 179.629 99.5255L203.868 5.69503C204.669 2.59336 200.407 -0.185768 194.349 -0.512802L14.862 -5.21343Z",
    fill: "#162C2B",
    fillOpacity: 0.05
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFiquePorDentroBackground);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/fique_por_dentro_background.e9edb31e65d67f45772d7436c019cc76.svg";